export enum SocialMediaShareTypeEnum {
	ChatShare = "Chat share",
	Other = "Other",
}
